// extracted by mini-css-extract-plugin
export default {"dark-mode":"CreateCustomTodoList_dark-mode__DDBiT","header":"CreateCustomTodoList_header__PlXCF","create-list-button":"CreateCustomTodoList_create-list-button__uXJ6-"};